<!--footer--->
<footer class="footer">

    <div class="foobot b5containeradjust">
      <div class="container">
        <div class="d-flex flex-column justify-content-center px-3 align-items-center">
          <div class="d-flex align-items-center ps-0">
            <span class="text-csm  d-block">Powered by NCRCB29</span>
            <a class="foofontstyle text-csm-ml ps-0 text-csm ml-md-5 text-decoration-underline" id="btn_PrivacyPolicy_Footer" name="btn_PrivacyPolicy_Footer" routerLink="/policy" href="https://justmoneycreditsav.co.za/policy" target="_blank">Privacy policy</a>
            <br/>
            <a class="foofontstyle text-csm-ml ps-0 text-csm ml-md-5 text-decoration-underline" id="btn_TermsConditions_Footer" name="btn_TermsConditions_Footer" routerLink="/terms" target="_blank"> T's and C's</a>
          </div>
       
          <div class="d-flex flex-column justify-content-around align-items-center mt-3 foot-logo-container">
            <p class="foot-logo-text">Credit Bureau data provided by</p>
            <img *ngIf="!showMyDataLogo" src="../../assets/images/vccb-logo.png"  width="130px" alt="vccb logo">
            <img *ngIf="showMyDataLogo" src="../../assets/images/mydata-logo.png"  width="130px" alt="mydata logo">
          </div>

        </div>
      </div>
    </div>
  </footer>
  <!--footer--->